import React, { useContext } from 'react'
import QuizSectionTemplate from '../QuizSectionTemplate'
import Explaination from '../Explaination'
import { Box, Flex, Text } from '@mantine/core'
import QuizParameterTemplate from '../QuizParameterTemplate'
import { QuizContext } from '@context/QuizContext'
import RoundButton from '@components/button/RoundButton'
import BackButton from '../BackButton'
import QuizParameterTemplatePercent from '../QuizParameterTemplatePercent'

const QuizSectionSix = () => {
    const {
        form6,
        nextStep,
        currentStep,
        investment_rate_for_expect_return_two_percent,
        investment_rate_for_expect_return_four_percent,
        investment_rate_for_expect_return_six_percent,
        investment_rate_for_expect_return_eight_percent,
    } = useContext(QuizContext)
    if (currentStep !== 6) {
        return <></>
    }

    console.log(form6?.errors)

    return (
        <form onSubmit={form6!.onSubmit(() => nextStep!())}>
            <Explaination />

            <QuizSectionTemplate
                section={6}
                title='จำนวนเงินที่ต้องนำมาลงทุนเพิ่ม'
            >
                <Box display={{ xs: 'none', md: 'block' }}>
                    <QuizParameterTemplate
                        afterLabel='บาท/เดือน'
                        label='ท่านควรนำเงินมาออมและลงทุนเพิ่มเติมเพื่อบรรลุเป้าหมายการเกษียณอายุ'
                        type='value'
                    >
                        จำนวนเงินลงทุน
                    </QuizParameterTemplate>
                </Box>
                <Text c='text.2' display={{ md: 'none', xs: 'block' }}>
                    ท่านควรนำเงินมาออมและลงทุนเพิ่มเติมเพื่อบรรลุเป้าหมายการเกษียณอายุ
                </Text>
                <QuizParameterTemplatePercent
                    label='กรณีคาดหวังผลตอบแทนจากการลงทุนก่อนเกษียณ'
                    percen='2.00%'
                    value={investment_rate_for_expect_return_two_percent!}
                />
                <QuizParameterTemplatePercent
                    percen='4.00%'
                    value={investment_rate_for_expect_return_four_percent!}
                />
                <QuizParameterTemplatePercent
                    percen='6.00%'
                    value={investment_rate_for_expect_return_six_percent!}
                />
                <QuizParameterTemplatePercent
                    percen='8.00%'
                    value={investment_rate_for_expect_return_eight_percent!}
                />
            </QuizSectionTemplate>
            <Flex
                mb='xl'
                direction={{ xs: 'column', sm: 'row' }}
                gap='lg'
                justify={{ xs: 'center', sm: 'space-between' }}
            >
                <BackButton />
                <RoundButton type='submit' label='สรุปผลการวิเคราะห์' />
            </Flex>
        </form>
    )
}

export default QuizSectionSix
